import PropTypes from 'prop-types';

export const activityMasteryPropTypeShape = {
    scoreBand: PropTypes.shape({
        mastered: PropTypes.number.isRequired,
        consolidating: PropTypes.number.isRequired,
        developing: PropTypes.number.isRequired,
        emerging: PropTypes.number.isRequired,
        needsImproving: PropTypes.number.isRequired
    }),
    goldBars: PropTypes.number,
    totalActivities: PropTypes.number
};

export const activityMasteryPropType = PropTypes.shape(
    activityMasteryPropTypeShape
);

export const courseInsightPropType = PropTypes.shape({
    levelObjectName: PropTypes.string,
    title: PropTypes.string,
    averageResult: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
});



// WEBPACK FOOTER //
// ./components/activity-status-bar/activity-mastery-prop-type.js